import { getTimeZoneFromOfficeString } from '@cue/data';

type ResourceTimeZoneSource = {
  timeZoneInfo: string;
};

export function resolveTimeZone(timeZone: string | null | undefined, fallback = 'UTC'): string {
  const normalizedTimeZone = timeZone?.trim();
  if (!normalizedTimeZone || normalizedTimeZone === 'Custom time zone') {
    return fallback;
  }

  return getTimeZoneFromOfficeString(normalizedTimeZone) ?? normalizedTimeZone;
}

export function getResourceTimeZone(source: ResourceTimeZoneSource | null | undefined, fallback = 'UTC'): string {
  return resolveTimeZone(source?.timeZoneInfo, fallback);
}
